module.exports = __webpack_public_path__ + "static/media/alice_deng.8662fe66.jpeg";